import { render, staticRenderFns } from "./MathLiveInput.vue?vue&type=template&id=3663d472&"
import script from "./MathLiveInput.vue?vue&type=script&lang=js&"
export * from "./MathLiveInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports